import { EUserType } from '@aeCore/enums/user-role.enum';
import { NavMenuInterface } from '@aeCore/interfaces/nav-menu.interface';

export const SUPER_ADMIN_MENU: NavMenuInterface[] = [
  {
    id: 1,
    label: 'USERS',
    icon: '',
    route: '/admin/users-list',
    permission: []
  },
  {
    id: 2,
    label: 'TIER_MANAGEMENT',
    icon: '',
    route: '/tier-management',
    permission: []
  },
  {
    id: 3,
    label: 'BRIDGE',
    icon: '',
    route: '/bridge',
    permission: []
  },
  {
    id: 4,
    label: 'TRANSACTIONS',
    icon: '',
    route: '/transactions',
    permission: []
  },
  {
    id: 5,
    label: 'ADMINS',
    icon: '',
    route: '/super-admin/admins-list',
    permission: []
  },
  {
    id: 6,
    label: 'ROLES',
    icon: '',
    route: '/roles',
    permission: []
  },
  {
    id: 7,
    label: 'WAITLIST',
    icon: '',
    route: '/waitlist',
    permission: ['role:view', 'role:add', 'role:edit', 'role:delete']
  },
  {
    id: 8,
    label: 'SETTINGS',
    icon: '',
    route: '/settings',
    permission: []
  },
  {
    id: 9,
    label: 'PAYMENT_METHODS',
    icon: '',
    route: '/payment-methods',
    permission: []
  }
];

export const ADMIN_MENU: NavMenuInterface[] = [
  {
    id: 1,
    label: 'USERS',
    icon: '',
    route: '/admin/users-list',
    permission: ['user:view', 'user:add', 'user:edit', 'user:delete']
  },
  {
    id: 2,
    label: 'TIER_MANAGEMENT',
    icon: '',
    route: '/tier-management',
    permission: []
  },
  {
    id: 3,
    label: 'BRIDGE',
    icon: '',
    route: '/bridge',
    permission: ['bridge:view_customers']
  },
  {
    id: 4,
    label: 'TRANSACTIONS',
    icon: '',
    route: '/admin/transactions',
    permission:  []
  },
  {
    id: 5,
    label: 'ADMINS',
    icon: '',
    route: '/super-admin/admins-list',
    permission: ['user:view_admin_details', 'user:view_admin', 'user:edit_admin_userinfo', 'user:delete_admin']
  },
  {
    id: 6,
    label: 'ROLES',
    icon: '',
    route: '/roles',
    permission: ['role:view', 'role:add', 'role:edit', 'role:delete']
  },
  {
    id: 7,
    label: 'WAITLIST',
    icon: '',
    route: '/waitlist',
    permission: ['role:view', 'role:add', 'role:edit', 'role:delete']
  },
  {
    id: 8,
    label: 'SETTINGS',
    icon: '',
    route: '/settings',
    permission: ['setting:view']
  },
  {
    id: 9,
    label: 'PAYMENT_METHODS',
    icon: '',
    route: '/payment-methods',
    permission: []
  }
];

export const USER_NAV_ITEMS: NavMenuInterface[] = [
  {
    id: 1,
    label: 'PROFILE',
    icon: '',
    route: 'profile',
    permission: [],
  },
  {
    id: 2,
    label: 'LIMITS',
    icon: '',
    route: 'limits',
    permission: [],
  },
  {
    id: 3,
    label: 'TRANSACTIONS',
    icon: '',
    route: 'transactions',
    permission: [],
  },
  {
    id: 4,
    label: 'BRIDGE',
    icon: '',
    route: 'bridge/customers',
    permission: [],
  },
];


export const NAV_MENU = {
  [EUserType.SUPER_ADMIN]: SUPER_ADMIN_MENU,
  [EUserType.ADMIN]: ADMIN_MENU,
  [EUserType.USER]: [],
};
